module.exports = __webpack_public_path__ + "img/11.5e13946f.png";